import antlr4 from 'antlr4'
import GrouperFormulaLexer from '@grouper/modules/core/formula/parser/generated/GrouperFormulaLexer'
import GrouperFormula from '@grouper/modules/core/formula/parser/generated/GrouperFormula'
import { GrouperFormulaParserError } from '@grouper/modules/core/formula/parser/errors'

/**
 * Attempts to parse an input string into a Grouper Formula. If it fails a
 * GrouperFormulaParserError will be raised.
 *
 * @param formula
 * @return {*} The resulting antlr4 parse tree of the formula
 */
export default function parseGrouperFormula(formula, throwOnError = true) {
  const chars = new antlr4.InputStream(formula)
  const lexer = new GrouperFormulaLexer(chars)
  const tokens = new antlr4.CommonTokenStream(lexer)
  const parser = new GrouperFormula(tokens)
  parser.removeErrorListeners()
  // noinspection JSUnusedLocalSymbols
  parser.addErrorListener({
    syntaxError: (recognizer, offendingSymbol, line, column, msg, err) => {
      if (throwOnError) {
        throw new GrouperFormulaParserError(offendingSymbol, line, column, msg)
      }
    },
  })
  parser.buildParseTrees = true
  return parser.root()
}

export function getTokenStreamForFormula(formula) {
  const chars = new antlr4.InputStream(formula)
  const lexer = new GrouperFormulaLexer(chars)
  const stream = new antlr4.CommonTokenStream(lexer)
  stream.lazyInit()
  stream.fill()
  return stream
}
